module.exports = __webpack_public_path__ + "img/cloud.849e970e.svg";